import * as angular from "angular";
import {NavianceSchoolWithProducts} from "../../models/school/naviance-school-with-products.model";
import {CurrentUser} from "../../models/user.model";
import {DistrictService} from "../../services/district/district.service";
import {UserSessionService} from "../../services/user-session/user-session.service";
import {LayoutUser} from "../../models/layout-window.model";
import {UserService} from "../../services/user/user.service";
import {Match} from "../../models/match.model";
import {MatchingService} from "../../services/matching/matching.service";

export interface CleverMatchInit {
    navianceSchools?: NavianceSchoolWithProducts[];
    matches?: Match[];
    currentUser: CurrentUser;
    tenantId: string;
}

export interface CleverMatchInitService { (tenantId: string): angular.IPromise<CleverMatchInit>; }

/* @ngInject */
export function cleverMatchInitService(
    userService: UserService,
    districtService: DistrictService,
    matchingService: MatchingService,
    userSessionService: UserSessionService,
    $q: angular.IQService
): CleverMatchInitService {

    function populateFooter(currentUser: CurrentUser) {
        let layoutUser: LayoutUser = {
            firstName: currentUser.firstName,
            lastName: currentUser.lastName
        };
        userSessionService.setLayoutUser(layoutUser);
    }

    return (tenantId: string): angular.IPromise<CleverMatchInit> => {
        let initData: CleverMatchInit = {
            currentUser: void 0,
            tenantId: tenantId
        };

        return userService.get().then((currentUser: CurrentUser) => {
            initData.currentUser = currentUser;
            let navianceSchoolsPromise = districtService.getNavianceSchools(tenantId)
                    .then((navianceSchools: NavianceSchoolWithProducts[]) => {
                initData.navianceSchools = navianceSchools;
            });

            let matchesPromise = matchingService.getMatchingSchools(tenantId).then((matches: Match[]) => {
                initData.matches = matches;
            });

            populateFooter(currentUser);
            return $q
                .all([navianceSchoolsPromise, matchesPromise])
                .then(() => initData);
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/clever-match-landing/clever-match-init/clever-match-init.service.ts